import ReviewForm from "./modules/ReviewForm";
import AnimateOnPageLinks from "./modules/AnimateOnPageLinks";
//import HeaderLarge from "./modules/HeaderLarge";
import Faqs from "./modules/Faqs";
import Tabs from "./modules/Tabs";
import Testimonial from "./modules/Testimonial";
import MobileMenu from "./modules/MobileMenu";
import ChangelogModal from "./modules/ChangelogModal";
import EddCartMods from "./modules/EddCartMods";
import DocsNav from "./modules/DocsNav";
import Toc from "./modules/Toc";
import NewsletterPopup from "./modules/NewsletterPopup";

jQuery(function ($) {

    ReviewForm.init();
    AnimateOnPageLinks.init();
    // HeaderLarge.init(); // This runs the animated background — disabling for now.
    Faqs.init();
    Tabs.init();
    Testimonial.init();
    MobileMenu.init();
    EddCartMods.init();
    NewsletterPopup.init();

    // Expression of interest form focus after scroll
    const REG_FORM = $('#registration-form');
    REG_FORM.one('scrolled_to', () => {
        REG_FORM.find('input').first().focus();
    });

    // Wrapping account related elements where necessary.
    $('.HookturnEddAccountWrap').find('table').wrap('<div class="HookturnEddTableWrap"></div>');

});

jQuery(window).load(() => {
    ChangelogModal.init();
    DocsNav.init();
    Toc.init();
});